import React, { createContext, useContext, ReactNode, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { workFlowTemplate } from 'apollo/templates/workFlow';

import { WorkFlow } from 'models/workflow-step';
import { ApolloError } from '@apollo/client';

type WorkflowStepsContextType = {
    workFlow: WorkFlow | null;
    loading: boolean;
    error: ApolloError | undefined;
};

const WorkflowStepsContext = createContext<WorkflowStepsContextType | undefined>(undefined);

export function WorkflowStepsProvider({ children }: { children: ReactNode }) {
    const { data, loading, error } = useQuery(workFlowTemplate);

    const value = useMemo(
        () => ({
            workFlow: data?.workFlow ?? null,
            loading,
            error,
        }),
        [data, loading],
    );

    return <WorkflowStepsContext.Provider value={value}>{children}</WorkflowStepsContext.Provider>;
}

export function useWorkflowSteps() {
    const context = useContext(WorkflowStepsContext);
    if (!context) {
        throw new Error('useWorkflowSteps must be used within a WorkflowStepsProvider');
    }
    return context;
}
